var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/**
 *
 * @author: Matthew Rawson @ 21/09/2017 17:51
 * @description: multiLineEllipsis truncation
 * @notes:
 * - applying this to a component that enforces min-height may break the effect
 */
import { css } from "styled-components";
export var singleLine = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"], ["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"])));
export var multiLine = function (linesToShow, lineHeight) { return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block; /* Fallback for non-webkit */\n  display: -webkit-box;\n  height: ", "px; /* Fallback for non-webkit */\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  display: block; /* Fallback for non-webkit */\n  display: -webkit-box;\n  height: ", "px; /* Fallback for non-webkit */\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    /**
     * @param: linesToShow {number}
     * @param: lineHeight {number}
     * @returns: {string}
     */
])), (linesToShow * lineHeight), linesToShow); };
/**
 * @param: linesToShow {number}
 * @param: lineHeight {number}
 * @returns: {string}
 */
export default (function (linesToShow, lineHeight) {
    if (linesToShow === 1) {
        return singleLine;
    }
    return multiLine(linesToShow, lineHeight);
});
var templateObject_1, templateObject_2;
